import { createActionGroup } from '@ngrx/store';

export const VideoActions = createActionGroup({
  source: 'Video',
  events: {},
});
